import { useState } from 'react';
import config from '../config';

export default function useSelectedStatuses(defaultStatuses, allStatuses) {
  let [selectedStatuses, setSelectedStatuses] = useState(defaultStatuses);

  const handleSelectedStatusesChange = (status) => {
    if (status) {
      if (selectedStatuses.includes(status)) {
        setSelectedStatuses(
          config.deleteItemFromArray(selectedStatuses, status)
        );
      } else {
        setSelectedStatuses([...selectedStatuses, status]);
      }
    }
  };

  const handleSelectDeselectAll = (checked) => {
    if (checked === true) {
      setSelectedStatuses(allStatuses);
    } else if (checked === false) {
      setSelectedStatuses([]);
    }
  };

  return [
    selectedStatuses,
    handleSelectedStatusesChange,
    handleSelectDeselectAll
  ];
}
